export enum TransactionsActionTypes {
  RECEIVED = 'transactions/RECEIVED',
  REQUEST = 'transactions/REQUEST',
  SHOW_NEW = 'transactions/SHOW_NEW',
  NEXT_RECEIVED = 'transactions/NEXT_RECEIVED',
  NEXT_REQUEST = 'transactions/NEXT_REQUEST',
  REQUEST_NEW = 'transactions/REQUEST_NEW',
  NEW_RECEIVED = 'transactions/NEW_RECEIVED',
}
